export enum WishlistError {
  MAX_WISHLISTS_REACHED = 'MAX_WISHLISTS_REACHED',
  UNKNOWN_ERROR = 'UNKNOWN_ERROR',
  UPDATING_DESCRIPTION = 'UPDATING_DESCRIPTION',
  UPDATING_NAME = 'UPDATING_NAME',
  WISHLIST_ID_NOT_FOUND = 'WISHLIST_ID_NOT_FOUND'
}

export interface Wishlist {
  readonly id: string;
  readonly name: string;
  readonly description: string | null;
  readonly isDefault: boolean;
  readonly items: ReadonlyArray<WishlistItem>;
}

export interface WishlistItem {
  readonly quantity: number;
  readonly sku: string;
  readonly id: string;
}
